import { getBaseCustomEvent } from './get-base-custom-event.helper';
import { getEventBase } from './get-event-base.helper';
import { pageview } from './page-view.helper';
import { getCustomEvent } from './custom-event.helper';
import { trackEvent } from './track-event.helper';
var sessionId = crypto.randomUUID();
var widget = process.env.REACT_APP_WIDGET_NAME || 'test-widget';
export function eventTracker() {
    function dispatch(type, payload) {
        var baseEvent = getEventBase({ type: type, sessionId: sessionId, widget: widget });
        if (!baseEvent)
            return;
        trackEvent({ baseEvent: baseEvent, data: payload });
    }
    function trackPageview() {
        var pageId = window.location.pathname.split('/').slice(1).join('_') || 'home';
        var pageViewEvent = getBaseCustomEvent({
            data: { value: pageId },
            type: 'page_view',
        });
        if (pageViewEvent)
            dispatch('page_view', pageViewEvent);
    }
    function trackClick(value) {
        var clickEvent = getBaseCustomEvent({ data: { value: value }, type: 'click' });
        if (clickEvent)
            dispatch('click', clickEvent);
    }
    function trackCustom(type, data, schema) {
        var customEvent = getCustomEvent({ type: type, data: data, schema: schema });
        if (customEvent)
            dispatch(type, customEvent);
    }
    var cleanup = pageview(trackPageview).cleanup;
    return {
        trackCustom: trackCustom,
        trackClick: trackClick,
        listenerCleanUp: [cleanup],
    };
}
